<script lang="ts" setup>
import Clutch from '~/assets/clutch.svg?component'
import Goodfirms from '~/assets/goodfirms.svg?component'
import Star from '~/assets/icons/star.svg?component'
</script>

<template>
  <div>
    <div class="mt-4 flex flex-wrap items-center justify-center gap-x-8 md:gap-x-16">
      <a
        href="https://clutch.co/profile/webamboos"
        target="_blank"
        rel="noreferrer noopener"
        aria-label="Clutch Reviews"
        class="flex flex-col items-center gap-y-2"
      >
        <div class="flex gap-x-1">
          <span class="font-bold text-main-700">4.8</span>
          <Star v-for="i in 5" :key="i" width="16" />
        </div>
        <Clutch class="h-6 py-px" />
        <Paragraph size="small"> {{ $t('home.reviews.clutch') }} </Paragraph>
      </a>

      <a
        href="https://www.goodfirms.co/company/webamboos"
        target="_blank"
        rel="noreferrer noopener"
        aria-label="Goodfirms Reviews"
        class="flex flex-col items-center gap-y-2"
      >
        <div class="flex gap-x-1">
          <span class="font-bold text-main-700">5.0</span>
          <Star v-for="i in 5" :key="i" width="16" />
        </div>
        <Goodfirms class="h-6" />
        <Paragraph size="small"> {{ $t('home.reviews.goodfirms') }} </Paragraph>
      </a>
    </div>
  </div>
</template>
